module.exports = __webpack_public_path__ + "static/media/top-time-active-light-icon.0beb15ba.svg";